export default __webpack_public_path__ + "static/media/help-desk-6.3c66e759.png";